import { IAsidePanelEvents, IAsidePanelFields } from '../../components/AsidePanel/types';
import { AsidePanel } from '../../components/AsidePanel/AsidePanel';
import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../types/types';
import { IAsidePanelCardPreviewSettingsHOCProps } from './types';
import { getAsidePanelIsMobile } from '../../store/selectors/getAsidePanelIsMobile';
import { onTabActive } from './effects/onTabActive';
import { onClose } from './events/onClose';
import { onResize } from '../AsidePanelHOC/events/onResize';
import { onResized } from '../AsidePanelHOC/events/onResized';
import { getCardPreviewBody } from './selectors/getCardPreviewBody';
import { getCardPreviewHeader } from './selectors/getCardPreviewHeader';
import { getCardPreviewFooter } from './selectors/getCardPreviewFooter';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IAsidePanelCardPreviewSettingsHOCProps
): IAsidePanelFields => {
    return {
        children: getCardPreviewBody(boardId),
        footer: getCardPreviewFooter(boardId),
        isMobile: getAsidePanelIsMobile(state),
        title: getCardPreviewHeader(boardId),
    }
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IAsidePanelCardPreviewSettingsHOCProps
): IAsidePanelEvents => {
    return {
        onTabActive: () => dispatch(onTabActive()),
        onClose: () => dispatch(onClose()),
        onResize: (width) => dispatch(onResize(width)),
        onResized: (width) => dispatch(onResized(width))
    }
};

export const AsidePanelCardPreviewSettingsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(AsidePanel);

AsidePanelCardPreviewSettingsHOC.displayName = 'AsidePanelCardPreviewSettingsHOC';
